// extracted by mini-css-extract-plugin
export default {"root":"UnderwritingCategoryConfigCard_root__fA7K7","icons":"UnderwritingCategoryConfigCard_icons__VKLA9"};